import { render } from "./AuthFooter.vue?vue&type=template&id=221d1047&scoped=true"
import script from "./AuthFooter.vue?vue&type=script&lang=js"
export * from "./AuthFooter.vue?vue&type=script&lang=js"

import "./AuthFooter.vue?vue&type=style&index=0&id=221d1047&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-221d1047"]])

export default __exports__